__turbopack_context__.v({
  "account-svg": "d3nXrG_account-svg",
  "flexAccount": "d3nXrG_flexAccount",
  "flexQuiz": "d3nXrG_flexQuiz",
  "navSwitcherFlex": "d3nXrG_navSwitcherFlex",
});
